import React from 'react';
import { useNavigate } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
import {DialogActions, DialogContentText } from '@mui/material';
import {Grid, Button, Box} from '@material-ui/core';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
///import {Edit, AttachFile, AddCircle, AddTask, PersonAdd, AddShoppingCartRounded, Comment, Handyman, FormatAlignJustify} from '@mui/icons-material';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
//import CaseSaveNew from './CaseSaveNew';
import LeadSave from './LeadSave'; 
// import OrderItems from './OrderItems';
// import OrderCouriers from './OrderCouriers'; 
// import OrderProductsDelivered from './OrderProductsDelivered';
// import PaymentsTab from '../payments/PaymentsTab';
import ActivitiesTable from '../activities/ActivitiesTable';
import FilesTable from '../files/FilesTable';
import Comments from '../comments/Comments';
import LeadStatusMenu from './LeadStatusMenu';
import CommentSave from '../comments/CommentSave';
// import Alert from './Alert';
import axios from 'axios';
import {API_URL} from '../utils/EnvVars';
import 'font-awesome/css/font-awesome.min.css';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {  
  const navigate = useNavigate();
  const childRefSaveNew = React.useRef();
	const childRefSaveEdit = React.useRef();
  const childRefComments = React.useRef();
  
  const [caseObj, setCaseObj] = React.useState({});
  const [open, setOpen] = React.useState(false); 
  const [openedTab, setOpenedTab] = React.useState('1');
  const [deleteDialogShow, setDeleteDialogShow] = React.useState(false);
  
  const [commentList, setCommentList] = React.useState([]);
  const [activitiesList, setActivitiesList] = React.useState([]);
  const [privilegesActivities, setPrivilegesActivities] = React.useState("");
  const [clickedActivitiesTab, setClickedActivitiesTab] = React.useState(false);
  const [filesList, setFilesList] = React.useState([]);
  const [privilegesFiles, setPrivilegesFiles] = React.useState("");
  const [clickedFilesTab, setClickedFilesTab] = React.useState(false);


  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  const deleteNow = () => {
    setDeleteDialogShow(false);
  };

  function deleteDialogHide(){
		setDeleteDialogShow(false);
	}

  React.useEffect(() => {
    setCommentList([]);
    setOpenedTab('1');
    setActivitiesList([]);
    setPrivilegesActivities("");
    setClickedActivitiesTab(false);
    setFilesList([]);
    setPrivilegesFiles("");
    setClickedFilesTab(false);
    if(open){ // only on open state
      if(props.caseObj && props.caseObj.autoId>0){
        setCaseObj(props.caseObj);
      }else if(props.leadId && props.leadId>0){
        getApiData();
      }
      getApiDataComments();
    }    
	}, [open,props.caseObj,props.leadId]);

  const handleChangeTabs = (event, newValue) => { 
      if(newValue==='2' && !clickedActivitiesTab){
        getApiDataActivities();
        setClickedActivitiesTab(true);
      }else if(newValue==='3' && !clickedFilesTab){
        getApiDataFiles();
        setClickedFilesTab(true);
      }
		  setOpenedTab(newValue);
  };

    async function getApiData(){ 
        let apiUrl=API_URL+'/crm-list-leads?leadId='+props.leadId;
        let axiosHeader = {
            'Content-Type': 'multipart/mixed',
            'device': 'web',
            'registerId': props.userObj.registerId,
					  'uid': props.userObj.loginId,
					  'fullName': props.userObj.fullName,
					  'token': props.userObj.token,
        };
        const config = {
          method: 'get',
          url: apiUrl,
          headers: axiosHeader
        }
        await axios(config)
          .then(response => {
          // setDataLoading(false);
          if(response && response.data && response.data.responseTxt==="success"){  
            if(response.data.list && response.data.list.length>0){
              setCaseObj(response.data.list[0]);	
            }								 				
            ///setPrivileges(response.data.privileges);
          }else if(response && response.data && response.data.responseTxt==="invalidtoken"){
            window.location.href='invalidtoken';
          }else if(response && response.data && response.data.responseTxt==="NoAuthorization"){
            //childRefAuthorization.current.handleClickOpen();
          }
        }).catch((error) => {
          })	
    }

   
    async function getApiDataComments(){ 
      let relatedToId=0;
      if(caseObj.autoId && caseObj.autoId>0){
        relatedToId = caseObj.autoId;
      }
		  let apiUrl=API_URL+'/crm-comments-cache?relatedTo=Lead&relatedToId='+relatedToId;
		  let axiosHeader = {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': props.userObj.registerId,
					'uid': props.userObj.loginId,
					'fullName': props.userObj.fullName,
					'token': props.userObj.token,
			};
			const config = {
				method: 'get',
				url: apiUrl,
				headers: axiosHeader
			}
			await axios(config)
			   .then(response => {
				if(response && response.data && response.data.responseTxt==="success"){  
            setCommentList(response.data.list);	
        }else if(response && response.data && response.data.responseTxt==="failed"){  
            setCommentList([]);
        }else if(response && response.data && response.data.responseTxt==="invalidtoken"){
          navigate('/invalidtoken');
				}
			})
	  }

    async function getApiDataActivities(){ 
		  let apiUrl=API_URL+'/crm-cache-activity?relatedTo=Lead&relatedToId='+caseObj.autoId;
		  let axiosHeader = {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': props.userObj.registerId,
					'uid': props.userObj.loginId,
					'fullName': props.userObj.fullName,
					'token': props.userObj.token,
			};
			const config = {
				method: 'get',
				url: apiUrl,
				headers: axiosHeader
			}
			await axios(config)
			   .then(response => {
				if(response && response.data && response.data.responseTxt==="success"){  
          setActivitiesList(response.data.list);	
          setPrivilegesActivities(response.data.privileges);
        }else if(response && response.data && response.data.responseTxt==="failed"){  
          setActivitiesList([]);
          setPrivilegesActivities("");
        }else if(response && response.data && response.data.responseTxt==="invalidtoken"){
					navigate('/invalidtoken');
				}
			})
	  }


    async function getApiDataFiles(){ 
		  let apiUrl=API_URL+'/crm-cache-files?relatedTo=Lead&relatedToId='+caseObj.autoId;
		  let axiosHeader = {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': props.userObj.registerId,
					'uid': props.userObj.loginId,
					'fullName': props.userObj.fullName,
					'token': props.userObj.token,
			};
			const config = {
				method: 'get',
				url: apiUrl,
				headers: axiosHeader
			}
			await axios(config)
			   .then(response => {
				if(response && response.data && response.data.responseTxt==="success"){  
          setFilesList(response.data.list);	
          setPrivilegesFiles(response.data.privileges);
        }else if(response && response.data && response.data.responseTxt==="failed"){  
          setFilesList([]);
          setPrivilegesActivities([]);
        }else if(response && response.data && response.data.responseTxt==="invalidtoken"){
					navigate('/invalidtoken');
				}
			})
	  } 

    function filesUpdatedList(list) {
      setFilesList(list);	
    }
    function activitiesUpdatedList(list) {
      setActivitiesList(list);	
    }    
    function doComment() {
      childRefComments.current.handleClickOpen();
    }
    function comments(list) {
      setCommentList(list);
    }
    function saveData(opt){
      if(opt===1){
        childRefSaveNew.current.handleClickOpen();
      }else if(opt===2){
        childRefSaveEdit.current.handleClickOpen();
      }
    }

    function updatedDetails(obj) {
      setCaseObj(obj);
    }

  return (caseObj?
    <>
      <Dialog fullScreen style={{margin:5}} maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-45px'}} onClose={handleClose}></DialogTitle>
          <DialogContent style={{height:'88vh'}}>
            <Grid item md={12} xs={12} >
                  <div className="btmbdrgry"><h3>{caseObj.title}</h3></div>
                  <p>
                  <Box>
                    <div style={{textAlign:'center',marginTop:15,marginBottom:10}}>
                      <i onClick={()=>{doComment()}} title="Comment" className="fa fa-comments-o btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
                      {/* {(props.privileges && props.privileges.indexOf("create")>-1)?
                        <i onClick={()=>{saveData(1)}} title="Clone" className="fa fa-clone btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
                      :null} */}
                      {(props.privileges && ((props.privileges.indexOf("update")>-1 && props.userObj.userId===caseObj.ownerId) || props.privileges.indexOf("modifyall")>-1) )?	
                        <i onClick={()=>{saveData(2)}} title="Edit" className="fa fa-pencil-square-o btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
                      :null}
                      {/* {(props.privileges && props.privileges.indexOf("delete")>-1)?
                        <i onClick={()=>{setDeleteDialogShow(true)}} title="Delete" className="fa fa-trash btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
                      :null} */}
                    </div>

						<Grid container style={{marginTop:-10}} >
            <Grid container >
                <Grid item md={6} xs={12} >
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Title
                      </Grid>
                      <Grid item xs={9}>
                        {caseObj.title}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Lead Number
                      </Grid>
                      <Grid item xs={9}>
                        {caseObj.leadNumber}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Lead Type
                      </Grid>
                      <Grid item xs={9}>
                        {caseObj.leadType}
                      </Grid>
                    </Grid>                    
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Status
                      </Grid>
                      <Grid item xs={9}>
                        <LeadStatusMenu channelId={caseObj.channelId} userObj={props.userObj} caseObj={caseObj} title={caseObj.status} />
                      </Grid>
                    </Grid>     
                  
                  {caseObj.parentStatus=='Lost'?
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                      Loss Reason
                      </Grid>
                      <Grid item xs={9}>
                        {caseObj.lossReason}
                      </Grid>
                    </Grid>
                  :null}  
                    
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                      Requirement in detail
                      </Grid>
                      <Grid item xs={9}>
                        {caseObj.remarks}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Lead Value
                      </Grid>
                      <Grid item xs={9}>
                        {caseObj.amount>0?<><i className='fa fa-inr'></i> {caseObj.amount}</>:null}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Contact Name
                      </Grid>
                      <Grid item xs={9}>
                        {caseObj.contactName}
                      </Grid>
                    </Grid>  
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Mobile
                      </Grid>
                      <Grid item xs={9}>
                      {(caseObj.mobile && caseObj.mobile.length>5)?<>
                        <a href={'https://wa.me/'+caseObj.mobile+'?text=Hello'} style={{textDecoration:'none'}} target='_blank' >
                          <i className="fa fa-whatsapp whatsAppBtnColor"></i> {caseObj.mobile}
                        </a>
                      </>:null}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Phone
                      </Grid>
                      <Grid item xs={9}>
                        {caseObj.phone}
                      </Grid>
                    </Grid>                    
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Email
                      </Grid>
                      <Grid item xs={9}>
                        {caseObj.email}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Address
                      </Grid>
                      <Grid item xs={9}>
                        {caseObj.address}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Pincode
                      </Grid>
                      <Grid item xs={9}>
                        {caseObj.pincode}
                      </Grid>
                    </Grid>                                                      
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Channel
                      </Grid>
                      <Grid item xs={9}>
                        {caseObj.channelName}
                      </Grid>
                    </Grid>                                       
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                      Remarks
                      </Grid>
                      <Grid item xs={9}>
                        {caseObj.remarks}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                      Tags
                      </Grid>
                      <Grid item xs={9}>
                        {(caseObj.tags && caseObj.tags.length>0)?caseObj.tags.replaceAll(',',', '):null}
                      </Grid>
                    </Grid>



                </Grid>       

                <Grid item md={6} xs={12} >
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                      Account
                      </Grid>
                      <Grid style={{cursor:'pointer'}} item xs={9} onClick={()=>{window.location='accountdetail?accountNumber='+caseObj.accountNumber}} >
                        {caseObj.accountName}{caseObj.accountNumber?<> / {caseObj.accountNumber}</>:null}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Customer Type
                      </Grid>
                      <Grid item xs={9}>
                        {caseObj.leadAccountType}                        
                      </Grid>
                    </Grid>                    
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Contact Person's Designation
                      </Grid>
                      <Grid item xs={9}>
                        {caseObj.designation}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Company
                      </Grid>
                      <Grid item xs={9}>
                        {caseObj.company}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Website
                      </Grid>
                      <Grid item xs={9}>
                        {caseObj.website}
                      </Grid>
                    </Grid>  
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                      Referral Partner
                      </Grid>
                      <Grid style={{cursor:'pointer'}} item xs={9} onClick={()=>{window.location='accountdetail?accountNumber='+caseObj.partnerAccountNumber}} >
                        {caseObj.partnerAccountName}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                       Rating
                      </Grid>
                      <Grid item xs={9}>
                        {caseObj.rating}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Industry
                      </Grid>
                      <Grid item xs={9}>
                        {caseObj.industry}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                      Source
                      </Grid>
                      <Grid item xs={9}>
                        {caseObj.source}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                      Campaign
                      </Grid>
                      <Grid item xs={9}>
                        {caseObj.campaignName}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                      Agent
                      </Grid>
                      <Grid item xs={9}>
                        {caseObj.ownerAlias} {caseObj.accessWithNames?<>,{caseObj.accessWithNames}</>:null}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Visibility
                      </Grid>
                      <Grid item xs={9}>
                        {caseObj.accessTypeTitle}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Forecast Close Date
                      </Grid>
                      <Grid item xs={9}>
                        {caseObj.forecastCloseDate}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Last Status Change Date
                      </Grid>
                      <Grid item xs={9}>
                        {caseObj.statusChangeDateTime}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Created By
                      </Grid>
                      <Grid item xs={9}>
                        {caseObj.createdAlias} {caseObj.createdDateTime}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Last Modified By
                      </Grid>
                      <Grid item xs={9}>
                        {caseObj.lastModifiedAlias} {caseObj.lastModifiedDateTime}
                      </Grid>
                    </Grid>



                </Grid>


            </Grid>

                
                

						</Grid>
					</Box>                      

									<Box style={{ width: '100%', typography: 'body1', marginTop: 10 }}>
										<TabContext value={openedTab}>
											<Box sx={{ borderBottom: 1, borderColor: 'divider', display:'flex', justifyContent:'center' }}>
											<TabList onChange={handleChangeTabs} variant="scrollable" scrollButtons="auto" aria-label="lab API tabs example">
                        <Tab label="Comments" value="1" />
                        <Tab label="Activities" value="2" />
												<Tab label="Files" value="3" /> 
											</TabList>
											</Box>
											<TabPanel value="1">
                        {/* COMMENTS LIST */} 
                         <Comments relatedTo={'Lead'} relatedToId={caseObj.autoId} showToCustomer={false} rows={commentList} userObj={props.userObj} comments={comments} /> 
                      </TabPanel>
											<TabPanel value="2"> 
                        {/* ACTIVITIES */}
                        <ActivitiesTable relatedTo='Lead' relatedToId={caseObj.autoId} relatedTitle={caseObj.title} accountId={caseObj.accountId} userObj={props.userObj} rows={activitiesList} privilegesActivities={privilegesActivities} activitiesUpdatedList={activitiesUpdatedList}  /> 
                      </TabPanel>
											<TabPanel value="3">
                        {/* FILES */}
                        <FilesTable relatedTo='Lead' relatedToId={caseObj.autoId} relatedTitle={caseObj.title} userObj={props.userObj} rows={filesList} privilegesFiles={privilegesFiles} filesUpdatedList={filesUpdatedList} /> 
                      </TabPanel>
                      

										</TabContext>
									</Box>

                  </p>
            </Grid>
          </DialogContent>
      </Dialog>


        <Dialog
					open={deleteDialogShow}
					onClose={deleteDialogHide}
					aria-labelledby="alert-dialog-section-title"
					aria-describedby="alert-dialog-section-description"
				>
					<DialogTitle id="alert-dialog-section-title">
						Alert
					</DialogTitle>
					<DialogContent>
					<DialogContentText id="alert-dialog-section-description">
						Are you sure, You want to delete student course.
					</DialogContentText>
					</DialogContent>
					<DialogActions>
					<Button variant="outlined" size="small" onClick={()=>{deleteDialogHide()}}>Don't Delete</Button>
					<Button variant="contained" size="small" color="secondary" onClick={()=>{deleteNow()}} autoFocus>Yes, Delete</Button>
					</DialogActions>
				</Dialog>

        
        {/* <Alert severityAlert={severityAlert} alertMessage={alertMessage} ref={childRefAlert} /> */}

			<LeadSave dataObj={caseObj} userObj={props.userObj} updatedDetails={updatedDetails} detailFlag={true} fullList={false} ref={childRefSaveEdit}  />
      <CommentSave relatedTo={'Lead'} relatedToId={caseObj.autoId} showToCustomer={false} updatedList={comments} userObj={props.userObj} ref={childRefComments} />

    </>:null
  );

});

export default CustomizedDialogs;